import { tips } from "@/mocks/home";
import Reveal from "@/pages/home/components/Reveal";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function Tips() {
  return (
    <section id="tips" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <Reveal>
        <SectionHeading
          tag="防走失"
          title="收藏与防走失的六个习惯"
          desc="地址会变，但好习惯不变。养成下面几个小习惯，就能在入口变化时依然快速回到正确页面。"
        />
      </Reveal>

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {tips.map((item, idx) => (
          <Reveal key={item.title} delay={idx * 50}>
            <div className="h-full rounded-lg border border-background-200 bg-background-50 p-5 md:p-6 hover:bg-background-100/70 transition-colors">
              <span className="w-11 h-11 rounded-md bg-secondary-100 text-secondary-700 flex items-center justify-center">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading font-bold text-foreground-950 text-base">
                {item.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}